export default __webpack_public_path__ + "static/default-author-image-1535e048b4a25d72ed51fce7159d0dac.png";